import { getDisplayValue } from "../../formatting/string-manipulation";
import type { SatelliteImage } from "../../types";
import type { Field } from "../tabs/types";

const emptySatelliteImage: SatelliteImage = {
  mediaLink: "",
  caption: "",
  source: "",
};

export function buildSatelliteImageryFields(
  satelliteImagery?: Array<SatelliteImage>,
  startIndex = 0,
  includeSource = false,
): Array<Field> {
  const images = satelliteImagery?.length
    ? satelliteImagery
    : [emptySatelliteImage];

  return images.flatMap(
    ({ mediaLink, caption, source }, imageIndex): Array<Field> => {
      const fieldIndex = startIndex + imageIndex * (includeSource ? 3 : 2);

      return [
        {
          name: includeSource
            ? `Satellite imagery ${imageIndex + 1} — media link`
            : `Media Link ${imageIndex + 1}`,
          type: "text",
          index: fieldIndex,
          value: getDisplayValue(mediaLink),
        },
        {
          name: includeSource
            ? `Satellite imagery ${imageIndex + 1} — caption`
            : `Caption ${imageIndex + 1}`,
          type: "text",
          index: fieldIndex + 1,
          value: getDisplayValue(caption),
        },
        ...(includeSource
          ? [
              {
                name: `Satellite imagery ${imageIndex + 1} — source (optional)`,
                type: "text",
                index: fieldIndex + 2,
                value: getDisplayValue(source),
              } satisfies Field,
            ]
          : []),
      ];
    },
  );
}
